import React, { useState, useEffect } from 'react';
import '../../css/spendHome.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import Heading from '../../components/Heading';
import SpendInsurance from '../../components/SpendBalanceSwithSelector/SpendInsurance';
import { useDispatch, useSelector } from 'react-redux';
import { setStartSpend } from '../../features/onboardingData/onboardingUserData';
import SpendInsuranceFinal from '../../components/SpendBalanceSwithSelector/SpendInsuranceFinal';
import SpendMarketPlace from '../../components/SpendBalanceSwithSelector/SpendMarketPlace';
import GifAnim from '../../components/GifAnim';
import CustomButtonSelectOption from '../../components/CustomButtonSelectOption';
import CustomButtonSelectOptionView from '../../components/CustomButtonSelectOptionView';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';

function SpendHome() {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isStartSpend = useSelector((state) => state.onboardingUserData.isStartSpend);
    const [selectedOption, setSelectedOption] = useState('option1');

    const options = ['option1', 'option2'];
    const optionText = ['Receber saldo', 'Gastar no marketplace'];

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(delay);
    }, []);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    useEffect(() => {
        // Map selectedOption to corresponding URL path
        const optionToPathMap = {
            "option1": "seguro",
            "option2": "marketplace",
        };

        // Get the corresponding path
        const path = optionToPathMap[selectedOption];

        // Navigate to the new URL
        navigate(`/gastar-saldo/${path}`, { replace: true });
    }, [selectedOption, navigate]);

    return (
        <>
            <Header />
            { isLoading ? 
                <GifAnim />
            :
            <div className={isTablet ? "mainViewContainerSpendHome" : (isMobile ? 'mainViewContainerSpendHomeTablet' : 'mainViewContainerSpendHomeMobile')}>
                <div className={isTablet ? 'firstTxtViewContainerSpendHome' : (isMobile ? 'firstTxtViewContainerSpendHomeTablet' : 'firstTxtViewContainerSpendHomeMobile')}>
                    <div className='mainHeadingViewContainerSpendHome'> 
                        <CustomBreadcrumbs hasPadding hasReceberSaldo={selectedOption === "option1"} hasGastarNoMarketplace={selectedOption === "option2"} />
                        <Heading  hasBtnBack={false} hasPadding />
                    </div>
                    <div className={isTablet ? 'secondMainContainerSpendHome' : (isMobile ? 'secondMainContainerSpendHomeTablet' : 'secondMainContainerSpendHomeMobile')}>
                        <div className={isTablet ? 'firstSubMainContainerSpendHome' : 'firstSubMainContainerSpendHomeMobile'}>
                            <div className='secondTitleViewSpendHome'>
                                <span className={isTablet ? 'textTitleRegular400SpendHome' : (isMobile ? 'textTitleRegular400SpendHomeTablet' : 'textTitleRegular400SpendHomeMobile')}>Gastar <span className={isTablet ? 'textTitleBold700SpendHome' : (isMobile ? 'textTitleBold700SpendHomeTablet' : 'textTitleRegular400SpendHomeMobile')}>saldo</span></span>
                            </div>
                            <div className='txtSecondTitleViewSpendHome'>
                                { selectedOption === 'option1' ?
                                    <div className='textSecondTitleViewSpendHome'>Use o saldo em compras no Marketplace ou receba-o na sua conta bancária, se tiver um seguro Médis individual.</div>
                                    :
                                    <div className='textSecondTitleViewSpendHome'>Pague menos no Marketplace ou receba o saldo na sua conta bancária.</div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className={isTablet ? 'secondMainContainerTwoSpendHome' : 'secondMainContainerTwoSpendHomeMobile'}>
                    { isTablet ?
                        <div className='swithSelectorContainerSpendHome' style={{ marginBottom: '48px' }}>
                            <CustomButtonSelectOption 
                                text={'Receber saldo'} 
                                onPress={() => handleOptionClick("option1")} 
                                isActive={selectedOption === 'option1'}
                            />
                            <CustomButtonSelectOption 
                                text={'Gastar no marketplace'} 
                                onPress={() => handleOptionClick("option2")} 
                                isActive={selectedOption === 'option2'}
                            />
                        </div>
                        : ( isMobile ?
                                <div className='swithSelectorContainerSpendHomeMobile' style={{ marginBottom: '48px' }}>
                                    <CustomButtonSelectOption 
                                        text={'Receber saldo'} 
                                        onPress={() => handleOptionClick("option1")} 
                                        isActive={selectedOption === 'option1'}
                                    />
                                    <CustomButtonSelectOption 
                                        text={'Gastar no marketplace'} 
                                        onPress={() => handleOptionClick("option2")} 
                                        isActive={selectedOption === 'option2'}
                                    />
                                </div>
                            :
                                <CustomButtonSelectOptionView 
                                    options={options} 
                                    optionText={optionText}
                                    onOptionChange={handleOptionClick}
                                />

                            )
                        }
                        <div className={isTablet ? 'firstSubMainContainerSpendHome' : 'firstSubMainContainerSpendHomeMobile'}>
                            {selectedOption === "option1" && (
                                <>
                                    {!isStartSpend ?
                                        <SpendInsurance />
                                        :
                                        <SpendInsuranceFinal />
                                    }
                                </>
                            )}
                            {selectedOption === "option2" && (
                                <SpendMarketPlace />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            }
            <Footer />
        </>
    )
}

export default SpendHome;